import * as THREE from 'three';

const SKY_VERT = `
varying vec3 vPos;
void main(){ vPos=position; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}
`;
const SKY_FRAG = `
varying vec3 vPos;
void main(){
  float h=normalize(vPos).y;
  vec3 top=vec3(.01,.005,.03);
  vec3 mid=vec3(.02,.01,.06);
  vec3 hor=vec3(.05,.02,.01);
  vec3 gnd=vec3(.03,.015,.008);
  vec3 col;
  if(h>0.) col=mix(hor,mix(mid,top,h*h),h);
  else col=mix(hor,gnd,min(1.,-h*2.));
  gl_FragColor=vec4(col,1.);
}
`;
const STAR_VERT = `
attribute float aBright;
varying  float vBright;
uniform  float uTime;
void main(){
  vBright=aBright;
  gl_PointSize=aBright*3.2;
  gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);
}
`;
const STAR_FRAG = `
varying float vBright;
uniform float uTime;
void main(){
  float a=vBright*(.65+sin(uTime*vBright*3.1)*.35);
  vec2 c=gl_PointCoord-.5;
  if(length(c)>.5)discard;
  gl_FragColor=vec4(1.,.98,.92,a*smoothstep(.5,.0,length(c)));
}
`;

export class EnvironmentSphere {
  constructor(scene) { this.scene = scene; this._starMat = null; }

  init() {
    const skyGeo = new THREE.SphereGeometry(1100, 32, 16);
    skyGeo.scale(-1, 1, -1);
    const skyMat = new THREE.ShaderMaterial({
      vertexShader: SKY_VERT, fragmentShader: SKY_FRAG,
      side: THREE.BackSide, depthWrite: false
    });
    this.scene.add(new THREE.Mesh(skyGeo, skyMat));

    const N = 4000;
    const pos = new Float32Array(N * 3);
    const bright = new Float32Array(N);
    for (let i = 0; i < N; i++) {
      const theta = Math.random() * Math.PI * 2;
      const phi   = Math.acos(2 * Math.random() - 1);
      const r     = 980;
      pos[i*3]   = r * Math.sin(phi) * Math.cos(theta);
      pos[i*3+1] = r * Math.sin(phi) * Math.sin(theta);
      pos[i*3+2] = r * Math.cos(phi);
      bright[i]  = Math.random() * 0.9 + 0.1;
    }
    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    geo.setAttribute('aBright',  new THREE.BufferAttribute(bright, 1));
    this._starMat = new THREE.ShaderMaterial({
      vertexShader: STAR_VERT, fragmentShader: STAR_FRAG,
      uniforms: { uTime: { value: 0 } },
      transparent: true, depthWrite: false
    });
    this.scene.add(new THREE.Points(geo, this._starMat));
  }

  update(time) {
    if (this._starMat) this._starMat.uniforms.uTime.value = time;
  }
}
